<template>
    <div class="input__container">
        <input 
            v-if="type === 'tel'"
            :type="'tel'" 
            :value="modelValue" 
            class="input-glow" 
            :placeholder="placeholder" 
            @input="$emit('update:modelValue', $event.target.value)" 
            :disabled="disabled"
            v-mask="phoneMask"
        >
        <input v-else
            :type="type || 'text'" 
            :value="modelValue" 
            class="input-glow" 
            :placeholder="placeholder" 
            @input="$emit('update:modelValue', $event.target.value)" 
            :disabled="disabled"
        >
        <span>{{ error }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            type: String,
            placeholder: String,
            disabled: Boolean,
            modelValue: String,
            error: String,
        },
        emits: ['update:modelValue'],
        computed: {
            phoneMask() {
                return {
                    mask: '+7 (FD#) ###-##-##',
                    tokens: {
                        F: {
                        pattern: /[3489]/,
                        },
                        D: {
                        pattern: this.modelValue?.[4] == '8' ? /[0-8]/ : /\d/,
                        },
                        '#': { pattern: /\d/ },
                    }
                }    
               
            }
        }
    }
</script>

<style lang="scss" scoped>
.input__container {
    position: relative;
    width: 190px;
    padding-bottom: 0.75rem;

    @media (max-width: 480px) {
        width: 100%;
    }


    input {
        width: 100%;
        line-height: 41px;
        padding: 0 .75rem;
        font-size: 1rem;
        font-weight: 400;
        color: #212529;
        background-color: white;
        border: 1px solid #dee2e6;
        appearance: none;
        transition: 0.5s ease-in-out;

        &:focus {
            border-color: #86b7fe;
            outline: 0;
            box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);
        }

        &:disabled {
            background-color: #e9ecef;
        }
    }

    span {
        position: absolute;
        top: 42px;
        left: 0;
        color: #ff144f;
        font-size: 0.75rem;
    }
}

</style>